<template>
  <div :class="cssTheme" class="k-list-participants">
    <div class="edit-response-details">
      <div class="response-heading">{{ $t('submit.editResponse') }}</div>
      <div
        v-if="isEmailVisible(participant)"
        class="km-participant-email text-very-small text-weight-light"
      >
        {{ getParticipantEmail(participant) }}
      </div>
    </div>
    <div :class="cssTheme" class="k-page-header text-grey">
      <div @click="onPrevious()" class="k-left-icon">
        <icon v-show="curParticipant > 0" type="backButton" />
      </div>
      <participantName
        v-if="participant"
        @click.native="startEditParticipant"
        :participant="participant"
        :isCurrentUser="isCurrentUser"
        :isEditable="isEditable(participant) && isPollEditable"
      />
      <!-- :isEmailVisible="isEmailVisible(participant)" -->

      <div @click="onNext()" class="k-right-icon">
        <icon
          v-show="curParticipant < participantCount - 1"
          type="nextButton"
        />
      </div>
    </div>
    <RenderMobileChoiceActionItem
      :participant="participant"
      :displaySuccessMessage="displaySuccessMessage"
      :isChoicesInViewMode="isChoicesInViewMode"
      :loading="loading"
      @onEdit="onEditButtonClick"
      @onSubmit="onSubmitButtonClick"
      @onCancel="revertUserChoice"
    >
    </RenderMobileChoiceActionItem>
    <div
      :class="cssTheme"
      class="text-very-small text-weight-regular zone-info justify-content-start px-3 align-items-center"
    >
      <div v-if="isDateType" :class="cssTheme" class="user-time-zone mr-1">
        <span class="">{{ $t('general.timeZone') }}: </span>
        {{ Intl.DateTimeFormat().resolvedOptions().timeZone }}
      </div>

      <div v-if="getInfoHTML" class="user-time-zone hidden-poll">
        {{ getInfoHTML }}
      </div>

      <!-- <div
        v-if="0 && submittingParticipant"
        @click="showHelp"
        class="ml-4 pointer d-inline ml-auto mb-2 mr-1"
      >
        <span class="fa-stack fa-2x">
          <font-awesome-icon
            class="text-primary fa-stack-2x text-size-16"
            :icon="['fas', 'circle']"
          />
          <font-awesome-icon
            class="text-white fa-stack-1x text-size-14"
            :icon="['fas', 'info']"
          />
        </span>
      </div> -->
    </div>
    <participantChoices
      :pollType="pollType"
      :choices="choices"
      :participant="participant"
      :isCurrentUser="participant.isCurrentUser"
      :showEditButton="!isChoicesInViewMode"
      :loading="loading"
      @whenUpdateChoice="compareChoices()"
      @toggle="updateAnswer()"
    />

    <ModalConfirm
      v-show="openUnSavedPopupModal"
      :msg="$t('options.warningMessageWhenEditResponse')"
      @cancel="revertChanges"
      @confirm="revertChangesAndMoveNextUser"
    />
    <ModalConfirm
      v-show="showConfirm && submittingParticipant"
      :msg="$t('options.dlgConfirmTitle')"
      :loading="false"
      :showNoButton="false"
      okLabel="OK"
      :width="450"
      @confirm="onCompleteOK"
      customClass="text-weight-semi-bold"
    >
      {{ $t('options.dlgConfirmBody') }}
    </ModalConfirm>

    <!-- multi votes maximum limit exceed error -->
    <ModalDialog
      ref="dlgMaximumVotesExceed"
      :title="$t('general.notAllowed')"
      :labelOk="$t('general.ok')"
      labelCancel=""
      :showCancelIcon="false"
      :displayCancelButton="false"
      @ok="reloadBrowser()"
      :displayOkButton="true"
    >
      <!-- replace true with isPaymentComplete in displayOkButton -->
      <div class="text-small" v-html="choiceUpdateErrorHTML"></div>
    </ModalDialog>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import participantName from './MobileParticipantName';
import participantChoices from './MobileParticipantChoices';
import RenderMobileChoiceActionItem from './RenderMobileChoiceActionItem.vue';
// import RenderHelpContent from './RenderHelpContent';

import Icon from '../UI/Icon.vue';
import { themeMixin } from '../mixins/ThemeMixins';
import { renderMixin } from '../mixins/RenderMixins';

export default {
  name: 'RendererMobileParticipants',
  props: ['initParticipant', 'submittingParticipant'],
  data() {
    return {
      showConfirm: false,
      curParticipant: 0,
      notificationMessage: '',
      currentUserCustomClass: '',
      dlgChoiceDialog: null,
      // participantBackup: null,
      loading: false,
      openUnSavedPopupModal: false,
      lastActionTakenByUser: '',
      displaySuccessMessage: false,
      isChoicesInViewMode: true,
      hideCommentTaskNavigationLayout: false,
      choiceUpdateErrorHTML: '',
    };
  },
  mixins: [renderMixin, themeMixin],
  components: {
    participantName,
    participantChoices,
    Icon,
    RenderMobileChoiceActionItem,
  },

  watch: {
    listOfParticipants() {
      this.compareChoices();
      this.curParticipant = this.initParticipant;
      console.error('New current participant', this.curParticipant);
    },

    submittingParticipant(newValue) {
      console.error('submittingParticipant ==> ', newValue);
      if (this.isChoicesInViewMode == true) {
        this.updateEditModeForUserBasedOnChoiceAnswered(newValue);
      }
    },

    getAdminBackUpPreferenceList(newValue) {
      if (this.participantBackup) {
        this.participantBackup.preference_list = newValue;
      }
    },

    getAdminUserName(newValue) {
      if (this.participantBackup) {
        this.participantBackup.name = newValue;
        if (this.participantBackup.user) {
          this.participantBackup.user.name = newValue;
        }
        console.log(
          'adminUserName (participantBackup) ==> ',
          this.participantBackup
        );
      }
    },

    // initParticipant(newValue) {
    //   console.error('initParticipant:', newValue);
    // },
  },

  methods: {
    updateAnswer() {
      // let found = false;
      // for (const obj of this.userChoicesValue.choices) {
      //   if (obj.choice_id == event.choice_id) {
      //     obj.value = event.value;
      //     found = true;
      //     break;
      //   }
      // }
      // if (found == false) {
      //   this.userChoicesValue.originalValue.push({
      //     choice_id: event.choice_id,
      //     value: event.originalValue,
      //   });
      //   this.userChoicesValue.choices.push({
      //     choice_id: event.choice_id,
      //     value: event.value,
      //   });
      // }
      // event.oneChoicePerParticipant = this.poll.options.oneChoicePerParticipant;
      // // this.$store.dispatch('updateChoiceWithoutAPIRequest', event);
      // this.toggleChoice(event.value, event.participant, event.choice_id);
      // this.userChoicesValue.participant = event.participant;
      this.hasSelectedAnyChoice = true;
    },
    startEditParticipant() {
      console.log('Start the edit dialog');
      if (!this.isPollEditable) return;
      // let participant = this.participants[this.curParticipant];

      // if (!this.isEditable ) return;
      // this.editParticipant = participant;
      // this.modalEditMode = true;
      // this.$refs.newParticipantModal.openModal();
      this.$emit('startEditParticipant');
    },

    onNext(forceFully = false) {
      if (
        forceFully == false &&
        !this.isChoicesInViewMode &&
        this.hasSelectedAnyChoice == true
      ) {
        this.lastActionTakenByUser = 'next';
        this.openUnSavedPopupModal = true;
      } else if (this.curParticipant < this.participantCount) {
        this.openUnSavedPopupModal = false;
        this.curParticipant++;
        this.$emit('next');
        this.resetUserChoiceVariable();
      }
    },

    onPrevious(forceFully = false) {
      if (
        forceFully == false &&
        !this.isChoicesInViewMode &&
        this.hasSelectedAnyChoice == true
      ) {
        this.lastActionTakenByUser = 'previous';
        this.openUnSavedPopupModal = true;
      } else if (this.curParticipant > 0) {
        this.openUnSavedPopupModal = false;
        this.curParticipant--;
        this.$emit('previous');
        this.resetUserChoiceVariable();
      }
    },
    getOpenInvitation() {
      if (this.curInvitation && !this.curInvitation.participant_id) {
        return this.curInvitation.id;
      }
      return null;
    },
    compareChoices() {
      this.notificationMessage = '';
      this.currentUserCustomClass = 'current-user-notification';
      //console.error("RenderMobileParticipant compareChoices:", this.participant);
      if (this.participant) {
        if (this.poll.choices == 0) {  // participant choices are depcricated
          return '';
        }
        let choicesCount = 0;
        for (let i = 0; i < this.participant.preference_list.length; i++) {
          if (this.participant.preference_list[i].value != -1) {
            choicesCount += 1;
          }
        }

        if (choicesCount == 0) {
          this.notificationMessage = 'options.noAnswerSubmitted';
          this.currentUserCustomClass += ' notification-red-bar';
        } else if (choicesCount < this.poll.choices.length) {
          this.notificationMessage = 'options.partialAnswerSubmitted';
          this.currentUserCustomClass += ' notification-yellow-bar';
        } else if (choicesCount == this.poll.choices.length) {
          this.notificationMessage = 'options.allAnswerSubmitted';
          this.currentUserCustomClass += ' notification-green-bar';
        }
      }
    },
    onEditButtonClick(participant) {
      console.log('onEditButtonClick -> participant ==> ', participant);
      this.isChoicesInViewMode = false;
      this.$emit('editSubmittingParticipant', {
        participant: participant,
        isChoicesInEditMode: !this.isChoicesInViewMode,
      });
      // if (this.submittingParticipant) return;s
      // this.submittingParticipant = participant;
      // this.updateEditModeForUserBasedOnChoiceAnswered(participant);
      const participantBackup = JSON.parse(JSON.stringify(participant));
      this.$store.commit('setParticipantBackup', participantBackup);
    },

    // ToDo - reuse the desctop call
    onSubmitButtonClick() {
      // console.log("onSubmitButtonClick ==> ", this.submittingParticipant, this.participant);
      if (
        !this.poll.options.limitedVotesPerChoice &&
        this.isAnswerEmpty(this.participant)
      ) {
        this.showConfirm = true;
        return;
      }

      this.completeSumitResponse();
    },

    onCompleteOK() {
      this.showConfirm = false;
    },

    completeSumitResponse() {
      const choices = [];

      this.submitting = true;

      for (var p of this.submittingParticipant.preference_list) {
        // if not selected any answer then select default NO
        if (
          this.poll.options.setDefaultAsNoForNotAnswered == true &&
          p.value == -1
        ) {
          p.value = 0;
        }
        const limit = this.poll.choices.find((c) => c.id == p.choice_id).limit;
        choices.push({
          choice_id: p.choice_id,
          value: p.value,
          answers: p.answers,
          limit: limit,
        });
      }

      const data = {
        choices: choices,
        oneChoicePerParticipant: this.poll.options.oneChoicePerParticipant,
        participantId: this.submittingParticipant.id,
      };
      console.log('submit Response for:', this.submittingParticipant, data);

      this.loading = true;
      this.$store.dispatch('updateChoicesV2', data).then((response) => {
        console.log(response);
        if (response.data.error) {
          this.choiceUpdateErrorHTML = this.createLimitErrorString(response);
          this.$refs.dlgMaximumVotesExceed.openModal();
        } else {
          this.displaySuccessMessage = true;
          setTimeout(() => {
            this.displaySuccessMessage = false;
            this.resetUserChoiceVariable();
          }, 1000);
        }
        this.loading = false;
      });
    },
    revertUserChoice() {
      if (this.participantBackup) {
        this.$store.commit('updateParticipant', this.participantBackup);
      }
      this.resetUserChoiceVariable();
    },
    resetUserChoiceVariable() {
      this.$store.commit('setParticipantBackup', null);
      // this.submittingParticipant = null;
      this.$emit('resetSubmittingParticipant');
      this.hasSelectedAnyChoice = false;
      this.isChoicesInViewMode = true;
    },
    revertChanges() {
      this.openUnSavedPopupModal = false;
    },
    revertChangesAndMoveNextUser() {
      this.revertUserChoice();
      if (this.lastActionTakenByUser == 'next') {
        this.onNext(true);
      } else if (this.lastActionTakenByUser == 'previous') {
        this.onPrevious(true);
      }
      this.lastActionTakenByUser = '';
    },
    getParticipantEmail(participant) {
      if (participant.user) {
        return participant.user.email;
      }
      return participant.email;
    },
    updateEditModeForUserBasedOnChoiceAnswered(participant) {
      if (participant != null) {
        this.isChoicesInViewMode = this.isAnyAnswerGiven(participant);
      } else {
        this.isChoicesInViewMode = true;
      }
    },
  },
  computed: {
    ...mapState({
      curInvitation: (state) => state.curInvitation,
      userId: (state) => state.Login.userId,
      ownerId: (state) => state.poll.poll.user.id,
      keyUserId: (state) => state.keyUserId,
      invitationId: (state) => state.invitationId,
    }),
    ...mapGetters([
      'isOwner',
      'isDarkMode',
      'isAdmin',
      'isPublicLink',
      'getAdminBackUpPreferenceList',
      'getAdminUserName',
    ]),

    isCurrentUser() {
      if (this.participant) {
        return this.participant.isCurrentUser;
      }
      return false;
    },

    choices() {
      return this.poll.choices;
    },

    pollType() {
      return this.poll.type;
    },

    listOfParticipants() {
      console.log('participants: ', this.poll.participants);
      let participants = this.poll.participants;
      return participants;
    },

    participantCount() {
      return this.participants.length;
    },

    participant() {
      return this.participants[this.curParticipant];
    },
    participantName() {
      return this.participants[this.curParticipant].name;
    },
    getInfoHTML() {
      if (
        this.poll.options.hiddenPoll ||
        this.poll.options.limitedVotesPerChoice
      ) {
        let html = ' ';
        let shownOption = 0;
        if (this.poll.options.limitedVotesPerChoice) {
          let optionText = this.$t('options.limitVotesPerChoice').replace(
            '%d',
            this.poll.options.votesLimit
          );
          if (shownOption > 0) {
            optionText = '; ' + optionText;
          }
          let optionHtml = optionText;
          html = html + optionHtml;
        }
        return html;
      }
      return null;
    },
  },

  mounted() {
    this.curParticipant = this.initParticipant;
    console.error('RenderdataMobile: mounted', this.participant);
    this.compareChoices();
    this.hasSelectedAnyChoice = false;
    if (this.submittingParticipant) {
      this.updateEditModeForUserBasedOnChoiceAnswered(
        this.submittingParticipant
      );
      const participantBackup = JSON.parse(
        JSON.stringify(this.submittingParticipant)
      );
      this.$store.commit('setParticipantBackup', participantBackup);
    }
  },
  created() {
    console.error('RenderdataMobile: created', this.participant);
  },
};
</script>

<style scoped lang="scss">
@import '@/styles/style.scss';

.k-left-icon,
.k-right-icon {
  flex-basis: 30px;
  font-size: 28px;
  display: flex;

  align-items: center;
  color: $primary;
}

.k-left-icon {
  margin-right: auto;
  justify-content: flex-start;
}

.k-right-icon {
  margin-left: auto;
  justify-content: flex-end;
}

.zone-info {
  width: 100%;
  display: flex;
  justify-content: center;
}
.current-user-notification {
  font-size: $standard;
  font-weight: $medium-weight;
  text-align: center;
  margin: 2px;

  border-radius: 3px;
}
.notification-red-bar {
  //background-color: $primary;
  color: $primary;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.notification-yellow-bar {
  //  background-color: $user-bubble;
  color: $checked-color;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.notification-green-bar {
  //background-color: $secondary;
  color: $checked-color;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.participant-status {
  margin: 2px;
  margin-left: 14px;
  margin-right: 14px;
  text-align: center;
}
.response-success {
  background-color: $primary-dark;
  color: $white;
}
.edit-response-details {
  text-align: center;
  .response-heading {
    font-weight: 600;
  }
}
.response-message {
  font-size: $very-small;
}

.fa-stack-1x {
  line-height: inherit;
}

.fa-stack-2x {
}

.fa-stack-1x,
.fa-stack-2x {
  position: absolute;
  left: 0;
  width: 100%;
  text-align: center;
}
</style>
